import { getTransactionList } from 'features/transactions/services';
import { getAuthorizationList } from 'features/authorization/services';
import { ITransactionLookupResult, ITransactionOption } from './types';

// Buscar transacción por Authorization ID
export const lookupByAuthorizationId = async (authorizationId: number): Promise<ITransactionLookupResult> => {
	const response = await getAuthorizationList(0, 1, [], { id: authorizationId });

	if (!response.data || !response.data.data || response.data.data.length === 0) {
		throw new Error('Autorización no encontrada');
	}

	const authorization = response.data.data[0];
	return {
		transactionId: authorization.transactionId,
		highlightAuthorizationId: authorizationId,
	};
};

// Buscar transacción por Authorization Code
export const lookupByAuthorizationCode = async (authorizationCode: string): Promise<ITransactionLookupResult> => {
	const response = await getAuthorizationList(0, 1, [], { authorizationCode });

	if (!response.data || !response.data.data || response.data.data.length === 0) {
		throw new Error('Código de autorización no encontrado');
	}

	const authorization = response.data.data[0];
	return {
		transactionId: authorization.transactionId,
		highlightAuthorizationId: authorization.id,
	};
};

// Buscar transacción(es) por E-Ticket
export const lookupByETicket = async (eticket: string): Promise<ITransactionLookupResult | ITransactionOption[]> => {
	const response = await getTransactionList(0, 10, [], { eticket });

	if (!response.data || !response.data.data || response.data.data.length === 0) {
		throw new Error('E-Ticket no encontrado en ninguna transacción');
	}

	// Si hay múltiples transacciones, devolver opciones
	if (response.data.data.length > 1) {
		return response.data.data.map((tx) => ({
			id: tx.id,
			orderId: tx.orderId,
			crmTicket: tx.crmTicket,
			isBitrixDeal: tx.isBitrixDeal,
			amount: tx.amount,
			coinCode: tx.coinCode,
			createdAt: tx.createdAt,
			cardholder: tx.cardholder,
		}));
	}

	// Si hay solo una, devolver directamente
	return {
		transactionId: response.data.data[0].id,
		highlightEticket: eticket,
	};
};
